import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

// Actions
import { getCampaignPlanOverview } from "../../../actions/campaign-plan/CampaignPlanActions";
import { getBasicCampaignDetails } from "../../../actions/campaign/CampaignBasicInfoActions";
import { getCampaignMedia } from "../../../actions/campaign-media/CampaignMediaActions";

// Utils and Constants
import { defaultPagination } from "../../../constants/UrlConstants";

// Components
import Spinner from "../../../components/spinner/Spinner";
import PageHeader from "../../../mavin/components/page-header/PageHeader";
import CampaignSidebar from "../../../components/campaign-sidebar/CampaignSidebar";
import { CampaignDetails } from "../components/HeaderNav";
import CityDetailsTable from "../components/CityDetailsTable";
import CampaignViewCards from "../components/CampaignViewCards";

/**
 * Page
 */
export default function CampaignCancelOverviewPage() {
  const dispatch = useDispatch();
  const { campaignId } = useParams();

  // Get campaignPlan
  const campaignPlanOverview = useSelector(
    (state) => state.campaignPlan.campaignPlanOverview
  );
  const { planByCity = {} } = campaignPlanOverview || {};

  // Get campaign
  const campaign = useSelector((state) => state.c_campaignBasicInfo.campaign);

  // Loadings
  const campaignPlanOverviewLoading = useSelector(
    (state) => state.campaignPlan.campaignPlanOverviewLoading
  );
  const basicCampaignDetailsLoading = useSelector(
    (state) => state.c_campaignBasicInfo.campaignLoading
  );
  const campaignMediasLoading = useSelector(
    (state) => state.campaignMedia.campaignMediaLoading
  );

  const isPageLoading =
    campaignPlanOverviewLoading ||
    basicCampaignDetailsLoading ||
    campaignMediasLoading;

  const { pageNo, pageSize } = defaultPagination;
  useEffect(() => {
    dispatch(getCampaignPlanOverview(campaignId));
    dispatch(getBasicCampaignDetails(campaignId));

    // campaign medias
    dispatch(getCampaignMedia(campaignId, pageNo, pageSize));
  }, [dispatch, campaignId]);

  // Sidebar Settings
  const redirectLinkObj = {
    campaignOverviewLink: `/campaign/${campaignId}/cancel`,
    citySummaryLink: `/campaign/${campaignId}/city/:cityId/cancel`,
  };

  // Page Title
  const pageTitle = <CampaignDetails campaign={campaign} />;

  // page loading
  if (isPageLoading) {
    return <Spinner className="spinner-center mt-2" />;
  }

  return (
    <>
      {/* SideBar */}
      <CampaignSidebar campaign={campaign} redirectLinkObj={redirectLinkObj} />

      {/* Content-Section */}
      <div className="content-wrapper px-0">
        <PageHeader title={pageTitle} shadow={true} />

        {/* Page-Content */}
        <div className="page-content">
          <CampaignViewCards
            campaign={campaign}
            campaignPlanOverview={campaignPlanOverview}
            mediaCount={campaign.mediaCount}
          />

          {/* City Details Table */}
          <CityDetailsTable planByCity={planByCity} campaign={campaign} />
        </div>
      </div>
    </>
  );
}
